module.exports = "/_next/static/images/webStoriesLogo-dc66d26a53f8265e0419f4de05da1b92.png";